import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ProfileUpdateDataServiceProvider {
	constructor(private http: HttpClient) {}

	changeUserName(user): Observable<any> {
		const url = '/protected/rest/user/edit';
		return this.http.post(url, user);
	}

	changeUserEmail(email: string): Observable<any> {
		const url = '/protected/rest/user/edit/login';
		return this.http.post(url, email);
	}

	changeUserPassword(
		password: string,
		password_confirm: string
	): Observable<Object> {
		const url = '/protected/rest/user/edit/password';
		const body = new FormData();
		body.append('password', password);
		body.append('password_confirm', password_confirm);

		return this.http.post(url, body);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/services/profile/profile-update.data.service.ts